(function (window) {
  'use strict';

  function handleSelectClick(e) {
    componentEvents.emitEvent('open-modal', [{
      id: 'product-variant-selector'
    }]);

    e.preventDefault();
  }

  function handleModalFormSubmit(e) {
    e.preventDefault();

    const select = document.querySelector('.js-select-pdp-variant-modal');
    const elements = e.target.elements;
    let newVariantId = null;

    componentEvents.emitEvent('close-modal', [{
      id: 'product-variant-selector',
      formReset: false
    }]);

    for (let i = 0; i < elements.length; i++) {
      if (elements[i].checked == true) {
        newVariantId = elements[i].value;
      }
    }

    // Update the select list that triggers the modal open.
    if (select) {
      select.value = newVariantId;
      triggerNativeEvent(select, 'change');
    }

    // Simulate the necessary pieces normally handled within product-detail.js
    // when switching variants.
    if (newVariantId) {
      const detailVariant = document.querySelector('.js-product-detail-variant--active');
      const carouselImages = document.querySelectorAll('.js-product-detail-carousel-image');
      const productInformation = document.querySelectorAll(`[data-product-id]`);
      const variantInformation = document.querySelectorAll(`[data-product-id="${newVariantId}"]`);

      // Assumes there is only 1 variant in the actual product-detail component.
      if (detailVariant) {
        detailVariant.setAttribute('data-id', newVariantId);
        window.componentEvents.emitEvent('active-product-variant', [
          {
            prescriptionAvailable: detailVariant.getAttribute('data-prescription-available') === 'true',
          },
        ]);
        window.componentEvents.emitEvent('update-product-data', [{
          sku: detailVariant.getAttribute('data-id'),
        }]);
      }

      // Update the carousel images to show the new variant.
      for (let i = 0; i < carouselImages.length; i++) {
        carouselImages[i].setAttribute('src', carouselImages[i].getAttribute('data-' + newVariantId));
      }

      for (let i = 0; i < productInformation.length; i++) {
        productInformation[i].classList.add('js-hidden');
      }
      for (let i = 0; i < variantInformation.length; i++) {
        variantInformation[i].classList.remove('js-hidden');
      }
    }
  }

  function init() {
    const select = document.querySelector('.js-select-pdp-variant-modal');
    const modalForm = document.querySelector('.js-modal-form.modal-form--product-variant-selector');

    if (select && !select.classList.contains('js-component-init-pdp')) {
      select.addEventListener('mousedown', handleSelectClick);
      select.classList.add('js-component-init-pdp');
    }

    if (modalForm && !modalForm.classList.contains('js-component-init')) {
      modalForm.addEventListener('submit', handleModalFormSubmit);
      modalForm.classList.add('js-component-init');
    }
  }

  // Allow application JS to reinitialize any instances added with Ajax, etc.
  if (typeof componentEvents !== 'undefined') {
    componentEvents.on('component-init', init);
  }

  init();

})(this);
